import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Footer() {
  return (
    <footer className="bg-black border-t border-white/5 pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-20">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-lg shadow-indigo-500/20">
                <span className="text-white font-black text-xl">K</span>
              </div>
              <span className="font-bold text-2xl tracking-tighter">Kuhako<span className="text-indigo-400">.pro</span></span>
            </div>
            <p className="text-slate-500 max-w-sm mb-8 leading-relaxed">
              The world's most trusted QR photo collection platform. Capturing once-in-a-lifetime memories for global events from London to Sydney.
            </p>
            <div className="flex gap-4">
              {[FiIcons.FiTwitter, FiIcons.FiInstagram, FiIcons.FiLinkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:border-indigo-500 transition-all">
                  <SafeIcon icon={Icon} />
                </a>
              ))}
            </div>
          </div>
          
          <div>
            <h5 className="font-bold mb-6 text-indigo-400 uppercase text-xs tracking-widest">Platform</h5>
            <ul className="space-y-4 text-slate-400 text-sm font-medium">
              <li><a href="#" className="hover:text-white transition-colors">How It Works</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Pricing</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Live Demo</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Event Templates</a></li>
            </ul>
          </div>

          <div>
            <h5 className="font-bold mb-6 text-indigo-400 uppercase text-xs tracking-widest">Global Reach</h5>
            <ul className="space-y-4 text-slate-400 text-sm font-medium">
              <li><a href="#" className="hover:text-white transition-colors">New York Events</a></li>
              <li><a href="#" className="hover:text-white transition-colors">London Weddings</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Tokyo Festivals</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-6 text-xs text-slate-600 font-bold uppercase tracking-widest">
          <p>© 2026 KUHAKO.PRO — EVERY MOMENT CAPTURED. LASTING MOMENTS ONLINE TODAY.</p>
          <div className="flex gap-6">
            <span className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" /> 
              System Operational
            </span>
            <span>Global CDN Enabled</span>
          </div>
        </div>
      </div>
    </footer>
  );
}